import React from "react";

export interface LocaleContextType {
  locale: string;
  setLocale: (locale: string) => void;
}

const defaultValue: LocaleContextType = {
  locale: 'fr',
  setLocale: () => { /* noop */ },
};

const LocaleContext = React.createContext<LocaleContextType>(defaultValue);

export default LocaleContext;